import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/pro-solid-svg-icons';
import allshipsLogo from '../../assets/allships-logo.png';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const close = () => {
    setOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className="as-navbar navbar navbar-expand-lg fixed-top">
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={close}>
          <img className="brand-icon" src={allshipsLogo} alt="Allships.com.au" />
          <span>
            Allships.com.au
            <span className="brand-tagline">Marine Master Training Tools</span>
          </span>
        </Link>

        {/* <button
          className="navbar-toggler border-0"
          type="button"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon icon={open ? faXmark : faBars} style={{ color: '#fff', fontSize: '1.1rem' }} />
        </button> */}

        {/* <div className={`collapse navbar-collapse ${open ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-1">
            <li className={`nav-item dropdown ${dropdownOpen ? 'show' : ''}`}>
              <button
                className="nav-link btn btn-link dropdown-toggle"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Marine Master Training Topics
              </button>
              <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
                <li><Link className="dropdown-item" to="/iala-buoyage-system-region-a" onClick={close}>IALA Buoyage System Region A</Link></li>
                <li><Link className="dropdown-item" to="/" onClick={close}>Nautical Knowledge Self Test</Link></li>
                <li><Link className="dropdown-item" to="/weather-observation-codes" onClick={close}>Weather Observation Codes</Link></li>
              </ul>
            </li>
          </ul>
        </div> */}
      </div>
    </nav>
  );
}
